export const environment = {
    'tracePropagationTargets': ['localhost', 'https://tardis-apim.staging.app.inh.re/adista/price-plan-admin', 'https://sso.inherent.fr'],
    'backendBaseUrl': 'https://tardis-apim.staging.app.inh.re/adista/price-plan-admin',
    'keycloakBaseUrl': 'https://sso.inherent.fr/',
    'keycloakRealm': 'pf-business-test',
    'keycloakClientId': '30b323f7-2cd4-4712-a9dd-541ad3e19fc8',
    'sentryDSN': 'https://f96f1c27700bcf9e74491b3c5451c829@sentry.prod.pf.inh.re/210'
};
